import { render, staticRenderFns } from "./DealerNews.vue?vue&type=template&id=8f26bf6a&"
import script from "./DealerNews.vue?vue&type=script&lang=js&"
export * from "./DealerNews.vue?vue&type=script&lang=js&"
import style0 from "./DealerNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports